<template>
  <v-inventory-create
    v-if="access.create_transfer"
    name="transfer"
    no-additional-cost
    ref="transfer"
    top_title="create_transfer"
  >
    <v-layout row>
      <v-flex class="mx-3">
        <v-autocomplete
          v-model="params.first_service"
          :label="$t('source_store')"
          item-value="_id"
          v-bind:items="services"
          item-text="name"
          ref="first_service"
          :rules="[fieldRules.required]"
        />
        <v-datetime-picker v-model="params.date" :label="$t('date')" />
      </v-flex>
      <v-flex class="mx-3">
        <v-autocomplete
          :label="$t('destination_store')"
          v-model="params.second_service"
          v-bind:items="services"
          item-value="_id"
          item-text="name"
          ref="second_service"
          :rules="[fieldRules.required]"
          persistent-hint
          :error-messages="
            params.first_service &&
            params.second_service == params.first_service
              ? 'Cannot be the same as source store'
              : ''
          "
        />
      </v-flex>
    </v-layout>
    <br />
    <template #items>
      <v-data-table
        v-bind:headers="headers"
        v-bind:items="items"
        :items-per-page="200000"
        hide-default-footer
        :no-data-text="$t('you_have_not_selected_items_yet')"
      >
        <template #[`item.product_name`]="{ item }">
          <v-list-item-content>
            <v-list-item-title>{{ item.product_name }}</v-list-item-title>
            <v-list-item-subtitle>SKU {{ item.sku }}</v-list-item-subtitle>
          </v-list-item-content>
        </template>
        <template #[`item.quality`]="{ item }">
          <v-text-field
            v-model="item.quality"
            :ref="'quality' + item._id"
            :rules="[fieldRules.require]"
            reverse
            type="number"
            @focus="$event.target.select()"
          />
        </template>
        <template #[`item.remove`]="{ item }">
          <v-btn icon v-on:click="remove_item(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <v-divider />
      <v-card-text>
        <v-search-items
          v-bind:label="$t('add_item')"
          v-bind:items="items_list"
          v-bind:selectedAct="add_item"
          v-bind:searchItems="getItems"
          v-bind:loading_inv_items="loading_inv_items"
          v-bind:rules="items && items.length == 0 ? [fieldRules.required] : []"
        ></v-search-items>
      </v-card-text>
    </template>
    <template #action>
      <v-btn v-on:click="cancel" text>{{ $t("cancel") }}</v-btn>
      <v-btn
        color="success"
        :loading="loading_transfer"
        text
        v-on:click="save"
        :disabled="saveDisabled"
        >{{ $t(target) }}</v-btn
      >
    </template>
    <v-dialog v-model="exist_dialog" persistent width="500">
      <v-card>
        <v-card-text class="pa-5 black--text"
          >This item has already been added</v-card-text
        >
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="exist_dialog = false">ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-inventory-create>
  <error404 v-else></error404>
</template>

<script>
import Services from "../../mixins/services";

export default {
  name: "TransferCreate",
  mixins: [Services],
  props: {
    itemsX: String,
    service_id: String,
  },
  data: () => ({
    headers: [
      { text: "Item", value: "product_name", width: 500 },
      { text: "Source stock", value: "source_stock", width: 100 },
      { text: "Destination stock", value: "destination_stock", width: 100 },
      { text: "Quantity", value: "quality", align: "right", width: 100 },
      { text: null, value: "remove" },
    ],
    items: [],
    items_list: [],
    item: null,
    params: {
      first_service: null,
      second_service: null,
      date: new Date().toISOString().substr(0, 10),
    },
    exist_dialog: false,
    search_text: "123",
    loading_inv_items: false,
    loading_transfer: false,
  }),
  computed: {
    target() {
      return this.$route.params["target"];
    },
    form() {
      const fObj = {
        first_service: this.params.first_service,
        second_service: this.params.second_service,
      };
      for (let i = 0; i < this.items.length; i++) {
        fObj["quality" + this.items[i]._id] = this.items[i].quality;
      }

      return fObj;
    },
    saveDisabled() {
      let formHasErrors =
        false ||
        this.params.first_service == this.params.second_service ||
        this.items.length == 0;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) formHasErrors = true;
      });
      return formHasErrors;
    },
  },
  watch: {
    "params.first_service"() {
      this.getItems(this.search_text, true);
      this.itemsRefresh();
    },
    "params.second_service"() {
      this.getItems(this.search_text, true);
      this.itemsRefresh();
    },
  },
  methods: {
    add_item(item) {
      let exist = false;
      for (const itm of this.items) {
        if (itm.product_id == item.product_id) {
          exist = true;
        }
      }
      if (exist) {
        this.exist_dialog = true;
      } else {
        this.items.push(this.$copy(item));
      }
    },
    remove_item(item) {
      const index = this.items.indexOf(item);
      this.items.splice(index, 1);
    },
    cancel() {
      if (this.target == "create") {
        this.$router.push({ path: "/inventory/transfer" });
      } else {
        this.$router.push({
          path: "/inventory/transfer/view",
          query: this.$route.query,
        });
      }
    },
    async update() {
      if (this.target == "update") {
        const transfer = this.$communicator.then(
          this,
          await this.$communicator("transfer", {
            arguments: [this.$route.query["id"]],
          })
        );
        if (transfer) {
          this.$refs["transfer"].init(transfer);
          this.items = transfer.items;
          this.params.date = new Date(transfer.date)
            .toISOString()
            .substr(0, 10);
          this.params.first_service = transfer.first_service;
          this.params.second_service = transfer.second_service;
        }
      }
    },
    async getItems(search, service_changed = false) {
      if (typeof search != typeof "invan") {
        search = "";
      }

      if (this.search_text == search && !service_changed) {
        return;
      }
      this.loading_inv_items = true;
      this.search_text = search;
      const items = this.$communicator.then(
        this,
        await this.$communicator("get_transfer_items", {
          arguments: [20, 1],
          params: {
            first_service: this.params.first_service,
            second_service: this.params.second_service,
            search: search,
          },
        })
      );
      if (items) {
        var items_list = [];
        const inStockMap = {};
        for (const index in items) {
          let search_text =
            items[index].name +
            this.converter(items[index].name) +
            items[index].sku;
          if (
            items[index].barcode &&
            typeof items[index].barcode == typeof []
          ) {
            for (const b of items[index].barcode) {
              search_text += b;
            }
          }
          inStockMap[items[index]._id] = {
            first: items[index].first,
            second: items[index].second,
          };

          items_list.push({
            product_id: items[index]._id,
            product_name: items[index].name,
            search_text: search_text,
            sku: items[index].sku,
            barcode: items[index].barcode,
            quality: null,
            source_stock: items[index].first,
            destination_stock: items[index].second,
          });
        }
        this.items_list = items_list;
      }
      this.loading_inv_items = false;
    },
    async itemsRefresh() {
      const ids = [];
      for (const item of this.items) {
        ids.push(item.product_id);
      }
      const items = this.$communicator.then(
        this,
        await this.$communicator("get_transfer_items_refresh", {
          params: {
            indexes: ids,
            first_service: this.params.first_service,
            second_service: this.params.second_service,
          },
        })
      );
      if (!(items instanceof Array)) {
        return;
      }
      const itemsMap = {};
      for (const itm of items) {
        itemsMap[itm._id] = itm;
      }
      for (const ind in this.items) {
        if (itemsMap[this.items[ind].product_id]) {
          this.items[ind].source_stock =
            itemsMap[this.items[ind].product_id].first;
          this.items[ind].destination_stock =
            itemsMap[this.items[ind].product_id].second;
        }
      }
    },
    async save() {
      this.loading_transfer = true;
      var params = this.$copy(
        Object.assign(this.params, this.$refs["transfer"].options())
      );
      params.date = new Date(params.date).getTime();
      var items = [];
      for (const index in this.items) {
        items.push({
          product_id: this.items[index].product_id,
          product_name: this.items[index].product_name,
          quality: this.items[index].quality,
        });
      }
      params.items = items;
      if (this.target == "create") {
        const response = this.$communicator.then(
          this,
          await this.$communicator("create_transfer", {
            params: params,
          })
        );
        if (response) {
          this.$router.push({
            path: "/inventory/transfer/view",
            query: {
              id: response._id,
            },
          });
        }
      } else {
        await this.$communicator("update_transfer", {
          arguments: [this.$route.query["id"]],
          params: params,
        });
        this.$router.push({
          path: "/inventory/transfer/view",
          query: this.$route.query,
        });
      }
      this.loading_transfer = false;
    },
  },
  mounted() {
    if (this.itemsX?.length > 0 && this.service_id) {
      this.params.second_service = this.service_id;
      this.items = JSON.parse(this.itemsX);
    }
    this.headers = [
      { text: this.$t("item"), value: "product_name" },
      {
        text: this.$t("source_stock"),
        value: "source_stock",
        width: 120,
        align: "right",
      },
      {
        text: this.$t("destination_stock"),
        value: "destination_stock",
        width: 130,
        align: "right",
      },
      {
        text: this.$t("quantity"),
        value: "quality",
        align: "right",
        width: 100,
      },
      { text: null, value: "remove", align: "center", width: 50 },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.update();
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
